import React from "react";
import { Grid } from "@material-ui/core";
import AllocationChart from "components/AllocationChart";
import { loadAllocationHistoriesByAssetClass } from "redux/allocationHistory/allocationHistoryFunctions";
import { useSelector, useDispatch } from "react-redux";
import { getReportDateSelector } from "redux/user/user";
import { RootState } from "redux/rootReducer";
import { AssetClass } from "types/AssetClass";
import { useTranslation } from "react-i18next";

interface Props {
  assetClass: AssetClass;
}

const AllocationHistory = (props: Props) => {
  const { t } = useTranslation();
  const { assetClass } = props;

  const dispatch = useDispatch();

  const reportControlId = useSelector((state: RootState) => state.user.reportControlId);
  const reportDate = useSelector(getReportDateSelector);

  const allocationHistory = useSelector(
    (state: RootState) =>
      state.allocationHistory[AssetClass[assetClass] as keyof typeof AssetClass]?.data ?? []
  );
  const allocationHistoryLoading = useSelector(
    (state: RootState) =>
      state.allocationHistory[AssetClass[assetClass] as keyof typeof AssetClass]?.loading
  );

  React.useEffect(() => {
    if (reportControlId && reportDate) {
      dispatch(loadAllocationHistoriesByAssetClass(assetClass, reportControlId, reportDate));
    }
  }, [dispatch, reportControlId, reportDate, assetClass]);

  return (
    <Grid item md={6} sm={12} style={{ marginBottom: 32, position: "relative" }}>
      <h3 style={{ color: "#444443", marginTop: 0 }}>{t("allocation_history")}</h3>
      <AllocationChart data={allocationHistory} loading={allocationHistoryLoading} />
    </Grid>
  );
};

export default React.memo(AllocationHistory);
